var axiosUrl = window.g.axiosConfig;
const { proUrl } = axiosUrl;

module.exports = {
  baseUrl: proUrl,
  projectName: '企业信息管理项目'
}
